export default __webpack_public_path__ + "static/media/refresh.58db8358.svg";